import { CHIPS_COLOR, Task } from "../../types/tasks";
import { User } from "../../types/users";
import KanbanColumnShell from "../common/KanbanColumnShell";
import TasksKanbanCard from "./TasksKanbanCard";

interface Props {
  status: string;
  tasks: Task[];
  users: User[];
  onDragStart: (id: string) => void;
  onDrop: (status: string) => void;
  onCardClick: (task: Task) => void;
}

function TasksKanbanColumn({ status, tasks, users, onDragStart, onDrop, onCardClick }: Props) {
  return (
    <KanbanColumnShell
      status={status}
      chipColor={(CHIPS_COLOR[status] as any) ?? "default"}
      count={tasks.length}
      width={260}
      onDrop={() => onDrop(status)}
    >
      {tasks.map((task) => (
        <TasksKanbanCard
          key={task._id}
          task={task}
          users={users}
          onDragStart={onDragStart}
          onClick={onCardClick}
        />
      ))}
    </KanbanColumnShell>
  );
}

export default TasksKanbanColumn;
